<template>
    <div><NotFound /></div>
</template>

<script>
import NotFound from "./views/404.vue";
export default {
    components: {
        NotFound: NotFound,
    },
};
</script>

<style lang="scss"></style>
